import firebase from 'firebase/app';
import 'firebase/database';

const database = firebase.database();
// if (process.env.NODE_ENV === 'development') {
//   database.useEmulator("192.168.5.39", 9000);
// }
const usersRef = database.ref('users/');

let tripObservers = [];

const tempAddOns = (tripId, addOns) => database.ref(`groups/${tripId}/addons`).set(addOns);

const observeCurrentUser = (context, user) => {
  const userRef = usersRef.child(user.uid);
  userRef.on('value', (snapshot) => {
    const docUser = { ...snapshot.val(), id: user.uid };
    context.commit('currentUserUpdated', docUser);
    context.commit('updateCollectionDocument', { collection: 'users', document: docUser });
    context.dispatch('getImageUrl', { path: `profile_pics/${user.uid}/profilePic.jpg`, id: user.uid });
  });
};

const observeUsers = (context, userIds) => {
  const { users } = context.rootState;
  const currentUserid = context.rootState.firUser.uid;
  Object.keys(userIds).forEach((userId) => {
    if (users[userId]) {
      // console.log(`not observing ${userId} already observing`);
      return;
    } if (userId === currentUserid) {
      // console.log(`not observing currentUser, it has separate observer`);
      return;
    }

    // console.log('fetching: ', userId)

    const userRef = usersRef.child(userId);
    tripObservers.push(userRef.toString());
    userRef.on('value', (snapshot) => {
      const document = { ...snapshot.val(), id: userId };
      context.commit('updateCollectionDocument', { collection: 'users', document });
      if (document.profile_pic) {
        context.dispatch('getImageUrl', { path: `profile_pics/${userId}/profilePic.jpg`, id: userId });
      }
    });
  });
};

const getUsers = (context, userIds) => {
  console.log("getting users", userIds);
  userIds.forEach((userId) => {
    const userRef = usersRef.child(userId);

    userRef.once('value').then((snapshot) => {
      const document = { ...snapshot.val(), id: userId };
      context.commit('updateCollectionDocument', { collection: 'users', document });
      if (document.profile_pic) {
        context.dispatch('getImageUrl', { path: `profile_pics/${userId}/profilePic.jpg`, id: userId });
      }
    });
  });
};

const pushNewContact = (tripId, contact) => database.ref(`groups/${tripId}/contacts`).push(contact);

const updateContect = (tripId, contactId, contact) => database.ref(`groups/${tripId}/contacts/${contactId}`).update(contact);

const deleteContact = (tripId, contactId) => database.ref(`groups/${tripId}/contacts/${contactId}`).remove();

const addFile = (tripId, ref, id) => database.ref(`groups/${tripId}/files`).child(id).set(ref);

const deleteFile = (tripId, fileId) => database.ref(`groups/${tripId}/files/${fileId}`).remove();

const observeTripPath = (context, tripId, collection) => {
  const ref = database.ref(`groups/${tripId}/${collection}`);
  ref.on("child_added", (snapshot) => {
    const document = { ...snapshot.val(), id: snapshot.key };
    context.commit('updateTripCollectionDocument', { collection, document });
  });
  ref.on("child_changed", (snapshot) => {
    const document = { ...snapshot.val(), id: snapshot.key };
    context.commit('updateTripCollectionDocument', { collection, document });
  });
  ref.on("child_removed", (snapshot) => {
    context.commit('deleteTripCollectionDocument', { collection, documentId: snapshot.key });
  });

  tripObservers.push(ref.toString());
};

const observeFiles = (context, tripId) => {
  const collection = "files";
  // diferent from observeTripPath as snapshot.val is a string and not an object
  const ref = database.ref(`groups/${tripId}/${collection}`);
  ref.on("child_added", (snapshot) => {
    const document = { value: snapshot.val(), id: snapshot.key };
    context.commit('updateTripDatabaseChild', { collection, document });
  });
  ref.on("child_changed", (snapshot) => {
    const document = { value: snapshot.val(), id: snapshot.key };
    context.commit('updateTripDatabaseChild', { collection, document });
  });
  ref.on("child_removed", (snapshot) => {
    context.commit('deleteTripCollectionDocument', { collection, documentId: snapshot.key });
  });

  tripObservers.push(ref.toString());
};

const observeContacts = (context, tripId) => {
  observeTripPath(context, tripId, 'contacts');
};

const getPaymentHistory = (companyId) => database.ref(`company/payments/${companyId}`).once('value').then((snapshot) => {
  const payments = snapshot.val();
  return Object.values(payments);
});

const observeTrip = (context, tripId) => {
  console.log("database observing trip", tripId);
  observeContacts(context, tripId);
  observeFiles(context, tripId);
};

const createNewUser = ((userId, name, email, dob) => usersRef.child(userId).set({
  name,
  email,
  phone: '',
  platform: "Web",
  dob,
  accept_terms: new Date().getTime(),
  account_type: 'free',
  other: '',
}));

const stopObservingUser = (userId) => usersRef.child(userId).off();

const updateProfile = (userId, user) => usersRef.child(userId).update(user);

const updateUserGroups = (userId, group, value) => usersRef.child(`${userId}/groups/${group}`).set(value);

const stopObservers = () => {
  tripObservers.forEach((ref) => {
    console.log(`removing observer at : ${ref}`);
    database.refFromURL(ref).off();
  });
  tripObservers = [];
};

const childByAutoId = () => database.ref().push().key;

export default {
  observeCurrentUser,
  observeUsers,
  getUsers,
  updateProfile,
  stopObservingUser,
  stopObservers,
  createNewUser,
  updateUserGroups,
  observeTrip,
  pushNewContact,
  updateContect,
  deleteContact,
  deleteFile,
  addFile,
  childByAutoId,
  tempAddOns,
  getPaymentHistory,
};
